import { Route } from 'react-router-dom';
import React from 'react';
import OYOChatWidget from '../services/Widgeting/widgets/OyoChatWidget';
import { guc } from '../services/Localisation';

export default class PublicRoute extends React.Component {

    constructor(props) {
        super(props);
    }
    render() {
        return <>
            {guc('oyo_chat_enabled') && <OYOChatWidget />}
            <Route exact path={this.props.path} component={this.props.component} />
        </>
    }
}
